import React, { useState, useEffect } from 'react';
import './darkmode.css';

const DarkModeToggle = () => {
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        // Default to LIGHT for everyone. Only go dark if the user explicitly
        // chose it before (saved in localStorage). We intentionally do NOT
        // follow the OS 'prefers-color-scheme' here, so light is always first.
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
            setIsDark(true);
            document.body.classList.add('dark-theme');
        }
    }, []);

    const toggleTheme = () => {
        setIsDark(!isDark);

        if (!isDark) {
            document.body.classList.add('dark-theme');
            localStorage.setItem('theme', 'dark');
        } else {
            document.body.classList.remove('dark-theme');
            localStorage.setItem('theme', 'light');
        }
    };

    return (
        <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            {isDark ? (
                <i className="uil uil-sun"></i>
            ) : (
                <i className="uil uil-moon"></i>
            )}
        </button>
    );
};

export default DarkModeToggle;